import { render, staticRenderFns } from "./user.vue?vue&type=template&id=497424bb&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "./user.vue?vue&type=style&index=0&id=497424bb&scoped=true&lang=css&"
import style1 from "./user.vue?vue&type=style&index=1&id=497424bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497424bb",
  null
  
)

export default component.exports